import { formatDate } from '@/shared';
import { IDataPlanificacion } from '@/shared/interfaces';
import { create } from 'zustand';

interface IPlanificacionStore {
  idFlota: number | undefined;
  setIdFlota: (idFlota: number) => void;

  idPreventa: number | undefined;
  setIdPreventa: (setIdPreventa: number) => void;

  planificaciones: IDataPlanificacion[];
  setPlanificaciones: (planificaciones: IDataPlanificacion[]) => void;

  fechaFinal: string | null;
  setFechaFinal: (fechaFinal: string | null) => void;

  fechaCalendario: string | null;
  setFechaCalendario: (fechaCalendario: string | null) => void;

}

export const usePlanificacion = create<IPlanificacionStore>(set => ({
  idFlota: undefined,
  setIdFlota: e => {
    set({ idFlota: e })
  },

  idPreventa: undefined,
  setIdPreventa: e => {
    set({ idPreventa: e })
  },

  planificaciones: [],
  setPlanificaciones(planificaciones) {
    set({ planificaciones: planificaciones })
  },

  fechaFinal: null,
  setFechaFinal(fechaFinal) {
    set({ fechaFinal: fechaFinal })
  },

  fechaCalendario: formatDate(new Date),
  setFechaCalendario(fechaCalendario) {
    set({ fechaCalendario: fechaCalendario })
  },


}));